/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_TitleInputs */

const en_mobile_benefits_title = /** @type {(inputs: Mobile_Benefits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to unlimited PDFs, papers, websites & books`)
};

const es_mobile_benefits_title = /** @type {(inputs: Mobile_Benefits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha PDFs, artículos, sitios web y libros ilimitados`)
};

/**
* | output |
* | --- |
* | "Listen to unlimited PDFs, papers, websites & books" |
*
* @param {Mobile_Benefits_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_title = /** @type {((inputs?: Mobile_Benefits_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_title(inputs)
	return en_mobile_benefits_title(inputs)
});